module.exports = __webpack_public_path__ + "media/vertical.126235ac.webm";